import { useQuery } from "@tanstack/react-query";
import { getUserProfilePicture, UserTeamsPictureKey } from "@/repository/queryFns/teams";
import { useEffect, useState } from "react";

const STALE_TIME = 24 * 60 * 60 * 1000;
const GC_TIME = 60 * 60 * 1000; // 1h

export const useUserPhoto = (userId: string | undefined, enabled: boolean) => {
	const { data: blob } = useQuery<Blob | null>({
		queryKey: [UserTeamsPictureKey, userId],
		queryFn: () => getUserProfilePicture(userId as string),
		enabled: enabled && !!userId,
		staleTime: STALE_TIME,
		gcTime: GC_TIME,
		retry: false,
	});

	const [photoUrl, setPhotoUrl] = useState<string | undefined>(undefined);

	useEffect(() => {
		let url: string | undefined;

		if (blob) {
			url = URL.createObjectURL(blob);
			setPhotoUrl(url);
		} else {
			setPhotoUrl(undefined);
		}

		return () => {
			if (url) {
				URL.revokeObjectURL(url);
			}
		};
	}, [blob]);

	return photoUrl;
};
